import React from 'react';
import style from './style.module.scss';
import { Tag, Button } from '@ontruck/orc';
import { CARRIER_STATES } from 'components/CarrierDetails/Constants';
import {
  ALLOW_STATE_UPDATE,
  featurePreferenceToggle,
} from '../../modules/preferences-manager/preferences';

const CarrierStatus = ({ carrier, activateCarrier, t }) => {
  const allowStateUpdate = featurePreferenceToggle(ALLOW_STATE_UPDATE);
  return (
    <div className={style.carrierStatus} data-testid="carrier-status">
      {carrier.status === CARRIER_STATES.not_active && (
        <>
          <Tag text={t.not_active} skin="modernLightGrey" weight="bold" size="M" />
          <Button
            skin="primary"
            size="L"
            text={t.activate_now}
            onClick={activateCarrier}
            disabled={!allowStateUpdate}
          />
        </>
      )}
      {carrier.status === CARRIER_STATES.banned && (
        <Tag text={t.banned} skin="modernRed" weight="bold" size="M" />
      )}
    </div>
  );
};

export default CarrierStatus;
